import ReactDOM from "react-dom";

/**
 * Creates a mounter for a fake MFE, compatible with our Router
 */
export const createFakeMfeMounter =
  (elem: JSX.Element) => (containerDiv: HTMLDivElement) => {
    ReactDOM.render(elem, containerDiv);
    return () => ReactDOM.unmountComponentAtNode(containerDiv);
  };
